<ng-container *ngIf="!onChatPage">
  <button
    type="button"
    class="launcher-button"
    [class.launcher-button--open]="isOpen"
    mat-mini-fab
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    (click)="toggle()"
    [matTooltip]="'ChatBot-Title' | translate: {Default: 'HR Assistant'}"
    [attr.aria-label]="'ChatBot-Title' | translate: {Default: 'HR Assistant'}"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="dialog">
    <mat-icon class="launcher-button__icon material-icons-outlined">{{ isOpen ? 'close' : 'auto_awesome' }}</mat-icon>
    <span *ngIf="session.unread() && !isOpen" class="launcher-button__dot" [style.background]="accent"></span>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    cdkConnectedOverlayPanelClass="chat-launcher-overlay"
    [cdkConnectedOverlayViewportMargin]="12"
    (backdropClick)="close()"
    (overlayKeydown)="$event.key === 'Escape' && close()"
    (detach)="close()">
    <div class="chat-panel" role="dialog" [attr.aria-label]="'ChatBot-Title' | translate: {Default: 'HR Assistant'}">
      <app-chat-bot variant="panel" (closed)="close()"></app-chat-bot>
    </div>
  </ng-template>
</ng-container>
